<!-- <div class="modal-wrap">
    
    <div class="modal-inner modal-fill-bill">
        <div class="modal-content">
            <div class="modal-header">
                <div class="row align-items-center">
                    <div class="col-9 text-right"><h2>{{detailsList?.biller_name | validate}}</h2></div>
                    <div class="col-3 text-right">
                        <img src="assets/img/bbps/bharat-connect.png" alt="barat-connect">
                    </div>
                </div>
                
            </div>
            <div class="modal-body">

                <form action="" [formGroup]="params_form">
                    <div *ngFor="let field of dataList" class="form-group">
                        <label class="mb-2" [for]="field.param_code">{{ field.param_name }}:</label>
                      
                        
                        <div [ngSwitch]="field.field_type">
                          <input *ngSwitchCase="'TEXT_FIELD'" class="form-control" 
                          [id]="field.param_code"
                          [disabled]="field.is_visible == '0'" 
                          [formControlName]="field.param_code" 
                          [placeholder]="field.param_name" 
                          [maxlength]="field.max_length" 
                          [minlength]="field.min_length"
                          />
         
                          <select *ngSwitchCase="'DROPDOWN'" class="form-control" 
                                  [formControlName]="field.param_code">
                            <option *ngFor="let option of field.supported_values" [value]="option">
                              {{ option }}
                            </option>
                          </select>
                          <div *ngSwitchCase="'radio'" class="form-check">
                            <div *ngFor="let option of field.options" class="form-check-inline">
                                <input class="form-check-input" 
                                     type="radio" 
                                     [value]="option.value" 
                                     [formControlName]="field.param_code" 
                                     [id]="option.value">
                                     <label class="form-check-label" [for]="option.value">
                                         {{ option.label }}
                                        </label>
                            </div>
                        </div>
                      
                          <div *ngSwitchCase="'autocomplete'">
                            <input matInput *ngFor="let option of field.options" 
                            class="form-control" 
                                   [formControlName]="field.param_code" 
                                   [placeholder]="field.param_name" />
                          </div>
                        </div>
                        
                        <div class="text-danger" *ngIf="params_form.get(field.param_code)?.invalid && params_form.get(field.param_code)?.touched">
                          <small *ngIf="params_form.get(field.param_code)?.errors?.['required']">
                              {{ field.param_name }} is required.
                            </small>
                          <small *ngIf="params_form.get(field.param_code)?.errors?.['minlength']">
                              Minimum length is {{ field.min_length }}.
                            </small>
                            <small *ngIf="params_form.get(field.param_code)?.errors?.['maxlength']">
                            Maximum length is {{ field.max_length }}.
                        </small>
                          <small *ngIf="params_form.get(field.param_code)?.errors?.['pattern']">
                              Invalid format.
                          </small>
                        </div>
                    </div>
                     
                    <div class="actions d-flex flex-wrap justify-content-center gap-3 mt-5">
                        <button class="custom-btn custom-btn-cancel"  (click)="cancel()">Cancel</button>
                        <button type="button" class="custom-btn custom-btn-primary"
                        
                        (click)="submit()"
                       >Fetch Bill</button>
                    </div>
                </form>
            </div>
        </div>
    </div>
    
</div> -->




<div *ngIf="dataList" class="data">
  <div class="text-right">
    <img src="assets/img/bbps/bharat-connect.png" alt="barat-connect">
  </div>

  <div class="card d-block ">

    <form action="" class="form-row" [formGroup]="params_form">

        <div *ngFor="let field of dataList" class=" form-group col-6 ">
          <!-- <label class="mb-2" [for]="field.param_code">{{ field.param_name }}:</label> -->

          <!-- Input Field for 'text' type -->


          <div [ngSwitch]="field.field_type">
            <input *ngSwitchCase="'TEXT_FIELD'" class="form-control" [id]="field.param_code"
              [disabled]="field.is_visible == '0'" [formControlName]="field.param_code" [placeholder]="field.param_name"
              [maxlength]="field.max_length" [minlength]="field.min_length" />
            <!-- <div *ngIf="field.data_type == 'NUMERIC'">
              <input *ngSwitchCase="'TEXT_FIELD'" class="form-control" 
              type="number"
              [id]="field.param_code"
              [disabled]="field.is_visible == '0'" 
              [formControlName]="field.param_code" 
              [placeholder]="field.param_name" 
              [maxlength]="field.max_length" 
              [minlength]="field.min_length"
              />
            </div> -->
            <!-- <div  *ngIf="field.data_type != 'NUMERIC'">
                    <input *ngSwitchCase="'TEXT_FIELD'" class="form-control" 
                    
                    [id]="field.param_code"
                    [disabled]="field.is_visible == '0'" 
                    [formControlName]="field.param_code" 
                    [placeholder]="field.param_name" 
                    [maxlength]="field.max_length" 
                    [minlength]="field.min_length" />
                  </div>    -->

            <!-- Select Dropdown for 'select' type -->
            <select *ngSwitchCase="'DROPDOWN'" class="form-control" [formControlName]="field.param_code">
              <option *ngFor="let option of field.supported_values" [value]="option">
                {{ option }}
              </option>
            </select>

            <!-- Radio Buttons for 'radio' type -->
            <div *ngSwitchCase="'radio'" class="form-check">
              <div *ngFor="let option of field.options" class="form-check-inline">
                <input class="form-check-input" type="radio" [value]="option.value" [formControlName]="field.param_code"
                  [id]="option.value">
                <label class="form-check-label" [for]="option.value">
                  {{ option.label }}
                </label>
              </div>
            </div>

            <!-- Autocomplete Input for 'autocomplete' type -->
            <div *ngSwitchCase="'autocomplete'">
              <input matInput *ngFor="let option of field.options" class="form-control"
                [formControlName]="field.param_code" [placeholder]="field.param_name" />
            </div>
          </div>

          <!-- Validation Errors -->
          <div class="text-danger"
            *ngIf="params_form.get(field.param_code)?.invalid && params_form.get(field.param_code)?.touched">
            <small *ngIf="params_form.get(field.param_code)?.errors?.['required']">
              {{ field.param_name }} is required.
            </small>
            <small *ngIf="params_form.get(field.param_code)?.errors?.['minlength']">
              Minimum length is {{ field.min_length }}.
            </small>
            <small *ngIf="params_form.get(field.param_code)?.errors?.['maxlength']">
              Maximum length is {{ field.max_length }}.
            </small>
            <small *ngIf="params_form.get(field.param_code)?.errors?.['pattern']">
              Invalid format.
            </small>
          </div>
        </div>


    </form>

  </div>

  <div class="actions d-flex flex-wrap gap-3 mt-5">
    <!-- <button class="custom-btn custom-btn-cancel"  (click)="cancel()">Cancel</button> -->
    <button type="button" [disabled]="params_form.invalid" class="custom-btn custom-btn-primary"
      (click)="submit()">Fetch Bill</button>
  </div>


</div>